<template>
  <div
    class="d-flex flex-column align-items-center justify-content-center min-vh-100"
  >
    <div v-if="loading" class="text-center">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="mt-3">Processing, please wait</div>
    </div>
    <div v-else-if="error" class="text-center">Error: {{ error }}</div>
    <div v-else class="text-center">Please continue on the BeNeat app</div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'AirbnbLoginCallback',
  data () {
    return {
      loading: true,
      error: null
    }
  },
  async created () {
    try {
      const code = this.$route.query.code
      if (code) {
        const { data } = await axios.get('airbnb/auth/callback', {
          params: {
            code: code
          }
        })
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.airbnbAuthHandler) {
          window.webkit.messageHandlers.airbnbAuthHandler.postMessage({
            refCode: data.ref_code
          })
        } else {
          console.error('WebView handler not available')
        }
      } else {
        this.error = 'No code provided'
      }
    } catch (error) {
      this.error = 'An error occurred. Please try again later.'
    } finally {
      this.loading = false
    }
  }
}
</script>

<style scoped>
.min-vh-100 {
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/airbnb/AirbnbLoginCallback.vue